import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import * as Icons from "lucide-react";
import api, { apiErr } from "@/lib/api";
import { useGuild } from "./DashboardLayout";
import { Toggle, PageHead } from "@/components/kit";

const iconMap = { trophy: Icons.Trophy, shield: Icons.Shield, terminal: Icons.Terminal, "door-open": Icons.DoorOpen,
  music: Icons.Music, sparkles: Icons.Sparkles, brain: Icons.Brain, ticket: Icons.Ticket, gift: Icons.Gift, "scroll-text": Icons.ScrollText };
const CONFIGURABLE = ["reaction_roles", "tickets", "giveaways"];

export default function Plugins() {
  const { guildId } = useGuild();
  const nav = useNavigate();
  const [plugins, setPlugins] = useState([]);
  const load = () => api.get(`/guilds/${guildId}/plugins`).then((r) => setPlugins(r.data));
  useEffect(() => { load(); }, [guildId]);

  const toggle = async (key, enabled) => {
    try { await api.put(`/guilds/${guildId}/plugins/${key}`, { enabled }); load(); toast.success(`Plugin ${enabled ? "enabled" : "disabled"}`); }
    catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
  };

  return (
    <div>
      <PageHead title="Plugins" desc="Extend your bot with one-click modules." />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {plugins.map((p) => {
          const Icon = iconMap[p.icon] || Icons.Blocks;
          return (
            <div key={p.key} data-testid={`plugin-${p.key}`} className={`bg-zinc-900 border rounded-xl p-5 transition-all flex flex-col ${p.enabled ? "border-volt/40" : "border-zinc-800"}`}>
              <div className="flex items-start justify-between mb-3">
                <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${p.enabled ? "bg-volt/15" : "bg-zinc-800"}`}><Icon className={`w-5 h-5 ${p.enabled ? "text-volt" : "text-zinc-500"}`} /></div>
                <Toggle testid={`plugin-toggle-${p.key}`} checked={p.enabled} onChange={(v) => toggle(p.key, v)} />
              </div>
              <h3 className="font-head font-semibold">{p.name}</h3>
              <p className="text-sm text-zinc-500 mt-1 flex-1">{p.desc}</p>
              {CONFIGURABLE.includes(p.key) && (
                <button data-testid={`plugin-configure-${p.key}`} onClick={() => nav(p.key === "reaction_roles" ? `/app/g/${guildId}/reaction-roles` : `/app/g/${guildId}/plugins/${p.key}`)}
                  className="mt-4 text-sm text-volt hover:text-volt-hover flex items-center gap-1 self-start">
                  <Icons.Settings2 className="w-4 h-4" /> Configure
                </button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
